import { useEffect, cloneElement, useMemo, useCallback } from 'react'
import VisibilitySensor from 'react-visibility-sensor'
import { Box } from '../../../../__aeki__/components/box/box.component'

import useValue from '../../../../__aeki__/hooks/use-value'

export const VisibleOpacity = (props: { children: any; delay?: number }) => {
  const [trigger, $trigger] = useValue()
  useEffect(() => {
    if (props.delay) {
      setTimeout(() => {
        $trigger.set(true)
      }, props.delay)
    } else {
      $trigger.set(true)
    }
  }, [])

  const componentProps = useCallback(
    (isVisible: boolean) => ({
      transition: '.4s ease',
      transitionProperty: 'opacity',
      opacity: isVisible && trigger ? 1 : 0.5,
    }),
    [trigger],
  )

  const component: any = useCallback(
    function visibilityCallback(params: any) {
      return (
        <Box baseline="none" style={componentProps(params.isVisible)}>
          {props.children}
        </Box>
      )
    },
    [props.children, trigger],
  )

  return <VisibilitySensor partialVisibility>{component}</VisibilitySensor>
}
